import { Alert, AlertTitle, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import useDescriptionAlert from './useDescriptionAlert.ts';
import { Close } from '@mui/icons-material';

const DescriptionAlert = () => {
  const { open, type, title, body } = useSelector((state: {'alert': any}) => state.alert);
  const { closeAlert } = useDescriptionAlert();

  return (
    <div>
      {open && (
        <Alert
          severity={type}
          action={
            <IconButton
              aria-label="close"
              data-testid="close-alert-button"
              color="inherit"
              size="small"
              onClick={() => {
                closeAlert();
              }}
            >
              <Close fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 0 }}
          aria-label="description alert"
        >
          <AlertTitle>{title}</AlertTitle>
          {body}
        </Alert>
      )}
    </div>
  );
};

export default DescriptionAlert;
